import React from 'react'
import Head from 'next/head'
import { AffiliateWrapper } from '../components/affiliate/styles'
import Hero from '../components/Hero'
import HeroImage from '../../public/affiliate/gs_affiliate_landing.jpg'
import HeaderContent from '../components/affiliate/HeaderContent'
import WhoWeAre from '../components/affiliate/WhoWeAre'
import WhyJoin from '../components/affiliate/WhyJoin'
import Questions from '../components/affiliate/Questions'
import Locations from '../components/events/Locations'
import WhatWereLookingFor from '../components/affiliate/WhatWereLookingFor'
import HowItWorks from '../components/how-it-works'

const Affiliate = () => {
  const handleClick = () =>
    window.open(
      'https://www.shareasale.com/shareasale.cfm?merchantID=138044',
      '_blank',
      'noopener, noreferrer'
    )

  const data = {
    'Apply to join': 'Share your contact information, social handles and why you want to join our program through our portal.',
    'Enjoy free glam': 'Receive complimentary services every month in exchange for content and social posting.',
    'Get insider access': `You'll be first in line for exclusive events, new services, brand partnerships and more.`
  }
  return (
    <>
      <Head>
        <title>Ambassador Program | GLAMSQUAD</title>
        <meta name="description" content="Join the GLAMSQUAD ambassador program. Earn complimentary beauty services, paid opportunities, and exclusive event invitations as a beauty tastemaker." />
        <link rel="canonical" href="https://glamsquad.com/affiliate" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Ambassador Program | GLAMSQUAD" />
        <meta property="og:description" content="Join the GLAMSQUAD ambassador program — complimentary services, paid opportunities, and exclusive events." />
        <meta property="og:url" content="https://glamsquad.com/affiliate" />
      </Head>
      <AffiliateWrapper>
        <Hero
          className="hero-component"
          image={HeroImage}
          content={<HeaderContent {...{ handleClick }} />}
        />
        <HowItWorks data={data} />
        <WhyJoin {...{ handleClick }} />
        <WhatWereLookingFor />
        <WhoWeAre {...{ handleClick }} />
        <Questions />
        <Locations intro='Our squad currently serves' />
      </AffiliateWrapper>
    </>
  )
}

export default Affiliate
